import { gql } from "@apollo/client";

export const DELETE_REPORTED_FEED = gql`
  mutation deleteReportedFeed($deleteReportedFeedArgs: DeleteReportedFeedInput!) {
    deleteReportedFeed(deleteReportedFeedArgs: $deleteReportedFeedArgs) {
      message
    }
  }
`;
